import React, { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Search } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Pill, Loader, Empty } from "@/components/Bits";

export const UsersPanel = () => {
  const [users, setUsers] = useState<any[] | null>(null);
  const [q, setQ] = useState("");

  const load = useCallback(() => {
    setUsers(null);
    api.get("/admin/users", { params: { q: q || undefined } })
      .then((r) => setUsers(r.data))
      .catch((e) => { toast.error(errMsg(e)); setUsers([]); });
  }, [q]);
  useEffect(load, [load]);

  const toggleOrganizer = async (u: any) => {
    try {
      await api.post(`/admin/users/${u.user_id}/organizer`, { grant: !u.is_organizer });
      toast.success(u.is_organizer ? `${u.name} is no longer an organizer.` : `${u.name} can now host events.`);
      load();
    } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div data-testid="admin-users-panel">
      <div className="flex items-center gap-2 border border-white/10 px-3 h-9 w-fit bg-white/[0.03] focus-within:border-neon/60 transition-colors">
        <Search size={14} className="text-white/40" />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search name or email" data-testid="users-search"
          className="bg-transparent outline-none text-sm w-56 placeholder:text-white/30" />
      </div>

      {users === null ? <Loader /> : users.length === 0 ? (
        <div className="mt-8"><Empty text="No users found." testid="users-empty" /></div>
      ) : (
        <div className="mt-8 grid gap-3">
          {users.map((u, i) => (
            <div key={u.user_id} className="border border-white/10 bg-ink-surface p-5 flex flex-wrap items-center gap-4" data-testid={`user-row-${i}`}>
              <div className="flex-1 min-w-[240px]">
                <div className="font-outfit font-semibold">{u.name}</div>
                <div className="mt-1 text-[12px] text-white/40">{u.email}</div>
              </div>
              <div className="flex flex-wrap gap-2">
                <Pill tone={u.role === "admin" ? "neon" : "neutral"}>{u.role}</Pill>
                {u.is_organizer && <Pill tone="yellow">organizer</Pill>}
                {u.badges?.includes("fellow") && <Pill tone="yellow">fellow</Pill>}
                {u.badges?.includes("verified") && <Pill tone="blue">verified</Pill>}
              </div>
              <button onClick={() => toggleOrganizer(u)} data-testid={`user-toggle-organizer-${i}`}
                className={`h-9 px-4 text-[11px] font-bold uppercase tracking-[0.16em] border transition-colors ${
                  u.is_organizer ? "border-white/20 text-white/60 hover:border-neon hover:text-neon" : "border-pcyellow/60 text-pcyellow hover:bg-pcyellow/10"}`}>
                {u.is_organizer ? "Revoke organizer" : "Make organizer"}
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
